import type { RootState } from '..';

export const selectTheme = (state: RootState) => {
  return state.preferences.theme;
};
